import { SocialMediaTypeMap } from '~/services/social_media_service';

export default {
    getMaxMessageLength: (state, getters, rootState) => {
        let websiteLength = 0;
        if (rootState.media.media.social_user_website) {
            if (rootState.media.media.social_media_networks.includes(SocialMediaTypeMap.TWITTER)) {
                websiteLength = state.twitter_url_length;
            } else {
                websiteLength = 100;
            }
        }

        if (rootState.media.media.social_media_networks.includes(SocialMediaTypeMap.TWITTER)) {
            return 280 - websiteLength;
        } if (rootState.media.media.social_media_networks.includes(SocialMediaTypeMap.LINKEDIN)) {
            return 3000 - websiteLength;
        }
        return 5000 - websiteLength;
    },
};
